/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorCreationItem } from './monitorCreationItem';


export interface MonitorCreationBulkResponse { 
    succeeded: Array<MonitorCreationItem>;
    failed: Array<MonitorCreationItem>;
}

